import iconMail from 'assets/img/user/img/icon-mail.svg';
import iconLang from 'assets/img/user/img/icon-lang.svg';
import iconPass from 'assets/img/user/img/icon-pass.svg';
import iconNotification from 'assets/img/user/img/icon-notification.svg';
import iconUrl from 'assets/img/user/img/icon-url.svg';
import iconToken from 'assets/img/user/img/icon-token.svg';


export const images = {
    mail: iconMail,
    language: iconLang,
    pass: iconPass,
    notification: iconNotification,
    url: iconUrl,
    token: iconToken,
};
